import isNull from 'lodash/isNull'
import Flickity from 'flickity'

export default class Blog {
    constructor() {
        this.cacheDom()
        this.resize()
    }

    cacheDom() {
        this.flkty = null
        this.lists = document.querySelector('.blog-filters-list')
    }

    resize() {
        const breakpoint = window.matchMedia('(min-width: 1024px)')

        if (breakpoint.matches) {
            this.destroy()
        } else {
            this.init()
        }
    }

    init() {
        if (!isNull(this.flkty)) {
            return
        }

        this.flkty = new Flickity(this.lists, {
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false
        })
    }

    destroy() {
        if (!isNull(this.flkty)) {
            this.flkty.destroy()
        }
    }
}
